import store from '@/store'
import { setStore } from '@/utils/setStore'

export default (vm) => {
  if (store.state.userInfo?.id) return true
  // setStore('longDialogShow', true)
}
